<template>
	<div class="row items flex">
		<div class="columns column12">
			<div class="gallery-wrapper flex wrap">
				<div
					v-for="item in items"
					:key="item.ID"
					class="columns column4 filter-item"
					:class="{ active: filter === item.galleryCategorie?.ID || filter === 'showAll' }"
				>
					<gallery-item :item="item" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});
</script>

<style lang="scss" scoped>
.gallery-wrapper {
	background: #fff;
	padding: var(--gap);

	.filter-item {
		margin: 0;
	}

	.column4 {
		width: calc(100% / 3 - (var(--gap)) * 2 / 3);
	}
}

@media (max-width: 920px) {
	.gallery-wrapper {
		.filter-item {
			width: calc(100% / 2 - (var(--gap)) * 1 / 2);
		}
	}
}

@media (max-width: 520px) {
	.gallery-wrapper {
		.filter-item {
			width: 100%;
		}
	}
}
</style>
